module.exports = __webpack_public_path__ + "img/wisesimulator.7f1a1f79.png";